module.exports = __webpack_public_path__ + "static/adoucisseur3-f7f0411aacdd31078f52667313684568.jpg";